module.exports = __webpack_public_path__ + "img/socLow.2c896de3.gif";